enum ImageType {
  logo = 'logo',
  imagen = 'imagen',
}

export default ImageType;
